export default "__VITE_ASSET__Dhdx$UtD__"